<!-- <div class="top-bar">
    <div class="left-svg">
        <svg width="241" height="48"  fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M10 0H195L240.365 47.9987H10V0Z" fill="#1e71e6"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0H185L230.365 47.9987H0V0Z" fill="#0049b1"/>
            </svg>

    </div>

    <div class="right-svg">
        <svg width="241" height="48"  fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M231 0H46.0001L0.634495 47.9987H231V0Z" fill="#1e71e6"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M241 0H56.0001L10.6345 47.9987H241V0Z" fill="#0049b1"/>
            </svg>

    </div>
</div> -->

<div class="navbar-area">
    <div class="mobile-nav">
        <a routerLink="/" class="logo"><img src="./../../../../assets/MyImgs/Logo/PIM Tek - 250 - Left Align.png"
                alt="Logo"></a>


    </div>

    <div class="main-nav ">
        <div class="container-fluid">
            <nav class="container-max-2 navbar navbar-expand-md navbar-light ">
                <a class="navbar-brand" routerLink="/"><img
                        src="./../../../../assets/MyImgs/Logo/PIM Tek - 250 - Left Align.png" class="mylogodesktop"
                        alt="Logo"></a>
                <div class="collapse navbar-collapse mean-menu" id="navbarSupportedContent">
                    <ul class="navbar-nav m-auto">
                        <li class="nav-item">
                            <a routerLink="/home" class="nav-link" routerLinkActive="active"
                                [routerLinkActiveOptions]="{exact: true}">Home </a>

                        </li>

                        <li class="nav-item" *ngIf="token"><a routerLink="/dashboard" class="nav-link"
                                routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">DashBoard</a></li>
                        <li class="nav-item" *ngIf="token"><a routerLink="/signals" class="nav-link"
                                routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Signals</a></li>
                        <li class="nav-item" *ngIf="token"><a routerLink="/holding" class="nav-link"
                                routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Holding</a></li>
                        <li class="nav-item"><a routerLink="/faqs" class="nav-link" routerLinkActive="active"
                                [routerLinkActiveOptions]="{exact: true}">FAQs</a></li>
                        <li class="nav-item"><a routerLink="/about" class="nav-link" routerLinkActive="active"
                                [routerLinkActiveOptions]="{exact: true}">About Us</a></li>

                        <li class="nav-item"><a routerLink="/contact" class="nav-link" routerLinkActive="active"
                                [routerLinkActiveOptions]="{exact: true}">Contact Us</a></li>

                        <div class="show-profile">
                            <!-- <li class="nav-item">
                                <a routerLink="/profile" class="nav-link" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}">Profile</a>
                            </li> -->

                            <li class="nav-item dropdown">
                                <a class="nav-link dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">  Profile  </a>
                                <ul class="dropdown-menu">
                                    <li><a class="dropdown-item" routerLink="/profile" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" > Profile</a></li>
                                    <li><a class="dropdown-item" routerLink="/change-password" class="nav-link"
                                        routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" > Change Password </a></li>
                                    <li class="nav-item"  *ngIf="token"><a class="dropdown-item" routerLink="/logout" class="nav-link"
                                        routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" > Logout </a></li>
                                    <li class="nav-item" *ngIf="!token"><a routerLink="/login" class="nav-link"
                                            routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Login</a></li>
                                </ul>
                            </li>
                        </div>
                    </ul>
                    

                    <div class="side-nav d-in-line align-items-center">
                        <!-- <div class="side-item">
                            <div class="search-box">
                                <i class="flaticon-loupe"></i>
                            </div>
                        </div>
                        <div class="side-item">
                            <div class="user-btn">
                                <a routerLink="/"><i class="flaticon-contact"></i></a>
                            </div>
                        </div> -->


                        <div class="side-item" *ngIf="!token">
                            <div (click)="On_Login()"><a class="mybtnlogin">Login <i
                                        class='bx bx-user header_icon'></i></a></div>

                        </div>

                        <div class="side-item" *ngIf="token">
                            <div class="dropdown">
                                <button class="myprofile dropdown-toggle" type="button" id="dropdownMenuButton1"
                                    data-bs-toggle="dropdown" aria-expanded="false">
                                    <img class="myproimg"
                                        src="https://images.pexels.com/photos/37819/pexels-photo-37819.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                                        alt="">

                                    <div class="proname">
                                        <p class="main-name">{{username}}</p>
                                        <p>{{email}}</p>
                                    </div>
                                </button>
                                <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                    <li><a class="dropdown-item" (click)="profile()">Profile</a></li>
                                    <li><a class="dropdown-item" (click)="change_password()">Change Password</a></li>
                                    <li><a class="dropdown-item" (click)="On_LogOut()">Log Out</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
        </div>
    </div>

    <div class="side-nav-responsive">
        <div class="container">
            <!-- <div class="dot-menu">
                <div class="circle-inner">
                    <div class="circle circle-one"></div>
                    <div class="circle circle-two"></div>
                    <div class="circle circle-three"></div>
                </div>
            </div> -->



            <div class="container">
                <div class="side-nav-inner">
                    <div class="side-nav justify-content-center  align-items-center">
                        <div class="side-item">
                            <div class="search-box">
                                <i class="flaticon-loupe"></i>
                            </div>
                        </div>
                        <div class="side-item">
                            <div class="user-btn">
                                <a routerLink="/"><i class="flaticon-contact"></i></a>
                            </div>
                        </div>
                        <div class="side-item">
                            <div class="nav-add-btn">
                                <a routerLink="/contact" class="nav-menu-btn">Contact Us <i class='bx bx-plus'></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>

<div class="search-overlay">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="search-layer"></div>
            <div class="search-layer"></div>
            <div class="search-layer"></div>

            <div class="search-close">
                <span class="search-close-line"></span>
                <span class="search-close-line"></span>
            </div>

            <div class="search-form">
                <form>
                    <input type="text" class="input-search" placeholder="Search here...">
                    <button type="submit"><i class="flaticon-loupe"></i></button>
                </form>
            </div>
        </div>
    </div>
</div>
